<template>
  <div class="yxtbiz-signup-order pb24 bc-cCF5">
    <div class="flex space-between w1200 mt24 align-left">
       <div class="w100p bc-cCFF">
        <div class="mt24 ml32 mr32 mb32">
          <div class="fs24 mb24">{{language().tit_order_form}}</div>
          <div class="bc-cCFA rtl4 rtr4 rbl4 rbr4 pt24 pl24 pr24 pb24">
            <div class="mb12 fw500 fs20 ellipsis lineClamp2 word-break">
              <yxtf-tag class="pl7 pr7 fs14 relative top-1" coverType="blue" size="small" type="info">{{data.appName}}</yxtf-tag>
              <span :title="data.projectName">{{data.projectName}}</span>
            </div>
            <div class="flex space-between rtl4 rtr4 rbl4 rbr4">
              <div class="w50p-12">
                <div class="mb8 c-cC8C relative">
                  <span class="justify ellipsis">{{language().lbl_admin}}</span>
                  <span>：</span>
                  <span class="c-cC26">
                    <yxtbiz-user-name slot="content" :name="(data.owners || []).map(_ => _.fullname).join('、') || '--'" split="、" />
                  </span>
                </div>
                <div v-for="(info, index) in extendedInfo" :key="index" :class="`c-cC8C relative ${index ? 'mt8' : ''}`">
                  <span class="absolute top0 inline-block w58 justify">{{info.label}}</span>
                  <span class="absolute top0 left58">：</span>
                  <span class="c-cC26 block pl70">{{info.value || '--'}}</span>
                </div>
              </div>
              <div class="w50p-12 align-right flex-end" v-if="data.pointPrice">
                <div>
                  <div class="mb8 c-cC8C relative">
                    <span class="inline-block">{{language().lbl_total_cost}}</span>
                    <span class="inline-block">：</span>
                    <span class="inline-block c-cC26">
                      <img class="d-integral relative top-5" :src="`${staticBaseUrl}assets/141df7bc/85e5b524/a27406.svg`" alt="" />
                      <span class="ml4 c-cC26 fs24 fw500">{{data.pointPrice}}</span>
                      <span class="ml4 c-cC75 relative top-3">{{language().msg_integral}}</span>
                    </span>
                  </div>
                  <div class="c-cC8C relative" v-if="points.totalMallPoint && !(users && users.length)">
                    <span class="inline-block">{{language().lbl_available_points}}</span>
                    <span class="inline-block">：</span>
                    <span class="inline-block c-cC26">{{points.totalMallPoint.toLocaleString()}}</span>
                  </div>
                </div>
              </div>
              <div class="w50p-12 align-right flex-end" v-else>
                <div class="c-cC8C relative top-2">
                  <span class="inline-block">{{language().lbl_total_cost}}</span>
                  <span class="inline-block">：</span>
                  <span class="inline-block c-cC59 fw500 fs20">{{language().msg_free}}</span>
                </div>
              </div>
            </div>
          </div>
          <template v-if="users && users.length">
            <div class="mt32">
              <div class="ml24 fs16 c-cC26 mb8">
                <span>{{language().tit_registration_list}}</span>
              </div>
              <div class="ml24 fs14 c-cC75 mb10" v-if="data.needAttach">{{language().msg_upload_demands}}</div>
              <div class="w100p clearfix">
                <div v-for="(user, index) in userList" :class="`pl24 relative pull-${index % 2 === 0 ? 'left' : 'right'} w50p-48 bc-cCF5-hover ${(ruleResultUsers[user.id] || (extraConditions && extraConditions[user.id]))?'bc-FAFAFA':''}`" :key="index">
                  <div class="h64 bb1 mr16">
                    <span class="inline-block mt10">
                      <yxtf-portrait  size="small" :imgUrl="user.imgUrl" :username="user.fullname"></yxtf-portrait>
                      <div class="inline-block ml8">
                        <div class="fs14 c-cC26 h22 inline-block">
                          <yxt-tooltip class="w150 ellipsis inline-block" effect="dark" placement="top" :open-filter="true">
                            <span>
                              <yxtbiz-dept-name :name="user.fullname || '--'" />
                            </span>
                            <div slot="content">
                              <yxtbiz-dept-name :name="user.fullname || '--'" />
                            </div>
                          </yxt-tooltip>
                        </div>
                        <div class="fs12 c-cC8C relative top-6 h20">{{points.userId === user.id ? language().lbl_self_registration : language().msg_all}}</div>
                      </div>
                    </span>
                    <i :class="`${(ruleResultUsers[user.id]|| (extraConditions && extraConditions[user.id]))?'x-open':'x-close'} absolute yxt-icon-close wh16 c-cC8C right20 fs16 top25 pointer`" @click.stop="del(user.id)"></i>
                    <span class="fs14 pull-right c-cC436BFF pointer mr46 pointer lh64 h64" v-if="data.needAttach && (!ruleResultUsers[user.id]  || (extraConditions && !extraConditions[user.id]))" @click.stop="openFile(user)">{{user.attachments && user.attachments.length ? `${language().btn_view_attachments}（${user.attachments.length}）` : language().btn_upload_attachments}}</span>
                    <span class="fs12 c-cC8C pull-right mr24 pointer lh64 h64">
                      <yxt-popover
                        v-if="ruleResultUsers[user.id] || (extraConditions && extraConditions[user.id])"
                        placement="top"
                        max-width="560"
                        max-height="300"
                        trigger="hover"
                        :visible-arrow="true"
                      >
                        <div  slot="reference">
                          <img width="16px" height="16px" :src="`${$staticBaseUrl}assets/141df7bc/74029ffb/a95b30.svg`" />
                          <span v-if="ruleResultUsers[user.id]|| (extraConditions && extraConditions[user.id])" class="relative top1 ml2">{{language().lbl_non}}</span>
                        </div>
                        <div class="yxtbiz-signup">
                          <div class="mah276">
                            <div class="c-cC26 fs16 mb4 fw500">{{language().tit_non}}</div>
                             <div class="c-cC75 fs14">{{data.requireCount===1?language().lbl_check_con1:language().lbl_check_con0}}</div>
                            <div v-for="(item, index) in ruleResultUsers[user.id]" :class="`fs14 c-cC26 ${index===0?'mt16':'mt24'}`" :key="index">
                              <span class="dot bc-cCD8 relative top-1"></span>
                              <span v-if="item.ruleCode==='cers'">{{item.ruleName}}（{{item.requireCount ===0?language().lbl_check_concer00:language().lbl_check_concer1}}）</span>
                              <span v-else-if="item.ruleCode==='exams'">{{item.ruleName}}（{{item.requireCount ===0?language().lbl_check_conexam00:language().lbl_check_conexam1}}）</span>
                              <span v-else>{{item.ruleName}}</span>
                              <br>
                              <span class="c-cC75 fs14 ml16 inline-block">{{item.ruleValueInfo}}</span>
                            </div>
                            <template v-if="extraConditions && extraConditions[user.id]  && extraConditions[user.id].length>0">
                              <div v-for="(item, index) in extraConditions[user.id]" :class="`fs14 c-cC26 ${index===0 && !ruleResultUsers[user.id] ?'mt16':'mt24'}`" :key="index">
                                <span class="dot bc-cCD8 relative top-1"></span>
                                <span  v-if="item.ruleCode==='cers'">{{item.ruleName}}（{{item.requireCount ===0?language().lbl_check_concer00:language().lbl_check_concer1}}）</span>
                                <span  v-else-if="item.ruleCode==='exams'">{{item.ruleName}}（{{item.requireCount ===0?language().lbl_check_conexam00:language().lbl_check_conexam1}}）</span>
                                <span  v-else>{{item.ruleName}}</span>
                                <br>
                                <span class="c-cC75 fs14 ml16 inline-block">{{item.ruleValueInfo}}</span>
                              </div>
                            </template>                           
                          </div>
                        </div>
                      </yxt-popover>                   
                    </span>
                  </div>
                </div>
              </div>             
              <div class="ml24 w100p c-cC59 fs12 mt16">
                <div v-html="text" class="inline-block"></div>
                <span class="c-cC436BFF fs12 inline-block ml16 pointer" @click.stop="delAll">{{language().mgs_removeall}}</span>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="ml24 mt32" v-if="data.needSurvey">
              <div class="fs16 c-cC26 mb8">
                <span>{{language().tit_registration_form}}</span>
                <span class="yxtf-form-item__required relative top-4">
                  <i class="required-dot"></i>
                </span>
              </div>
              <div class="bc-cCF5 pt12 pb12 pl16 pr16 rtl4 rtr4 rbl4 rbr4">
                <div class="relative pl24">
                  <yxtf-svg class="absolute left0 top-2" width="24px" height="24px" icon-class="icons/f_proj-research" />
                  <span class="fs14 c-cC59 ml4">{{data.surveyTemplateName}}</span>
                  <yxtf-button class="pull-right" size="small" plain @click.stop="openSurvey" v-if="!needSurveyValue">{{language().btn_fill_out_the_form}}</yxtf-button>
                  <yxtf-svg class="relative top4 pull-right" width="16px" height="16px" icon-class="icons/f_feedback-success" v-else />
                </div>
              </div>
            </div>
            <div class="ml24 mt32" v-if="data.needAttach">
              <div class="fs16 c-cC26 mb8">
                <span>{{language().tit_upload_attachments}}</span>
                <span class="yxtf-form-item__required relative top-4">
                  <i class="required-dot"></i>
                </span>
              </div>
              <div>
                <div class="fs14 h24 c-cC8C mb16">{{language().msg_upload_info.replace('$types', data.attachTypeOptionList.map(_ => ({ 1: language().lbl_file, 2: language().lbl_picture, 3: language().lbl_video }[_])).join('、'))}}</div>
                <div class="wh120 center pointer" v-if="attachments.length < uploadConfig.max">
                  <yxtbiz-upload
                    class="wh120"
                    icon-class="plus"
                    config-key="AttachConfigKey"
                    :filters="filters"
                    :app-code="uploadConfig.appCode"
                    :module-name="uploadConfig.moduleName"
                    :function-name="uploadConfig.functionName"
                    md5
                    :before-upload="beforeUpload"
                    :on-progress="onProgress"
                    :on-uploaded="onUploaded"
                    :on-error="onError"
                    :drag="true"
                  ></yxtbiz-upload>
                </div>
                <div class="c-cC75 fs14 mt16">
                  <div v-for="(item, index) in attachments" :key="index" :class="`w50p-14 mb8 h40 lh40 bc-cCF5-hover rtl4 rtr4 rbl4 rbr4 inline-block ${(index % 2) === 1 ? 'ml28' : ''}`">
                    <yxtf-svg class="wh24 relative left-3 top4 ml8" :icon-class="`icons/${getIconName(item.fileClass)}`" />
                    <span class="fs14 c-cC26 relative top6 h20 inline-block ellipsis w148-max" :title="item.name && item.name.replace(/\.[^.]+$/, '')">{{item.name && item.name.replace(/\.[^.]+$/, '')}}</span>
                    <span class="fs14 c-cC8C relative top1">.{{item.name && item.name.split('.').pop()}}</span>
                    <span class="fs14 c-cC8C ml8 relative top1">{{getSize(item.size)}}</span>
                    <span class="x-close fs14 c-cC8C ml8 pull-right mr16 pointer" @click.stop="close(item.uuid)">
                      <yxtf-svg class="relative top4" width="20px" height="20px" icon-class="delete-1" />
                    </span>
                    <span class="fs14 c-cC8C ml8 relative top2 mr18 pull-right wh159-40" v-show="!item.error && item.progress !== 100">
                      <yxtf-progress class="relative top-3" :percentage="item.progress">
                        <span slot='content' class="c-cC75">{{item.progress}}%</span>
                      </yxtf-progress>
                    </span>
                    <span :class="`fs12 ml8 relative top1 pull-right mr12 w48 ${!item.error ? 'c-cC8C' : 'c-cCRed'}`">{{item.error ? language().lbl_upload_failed : (item.progress === 100 ? language().lbl_upload_success : language().lbl_uploading_now)}}</span>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <div :class="data.needAttach || data.needSurvey ? 'ml24 mt32 justify-content-center inline-flex w100p' : 'ml24 mt32 justify-content-center inline-flex w100p'">
            <!-- <yxtf-button size="larger2" type="primary" :disabled="needAttachDisabled || (userList.length ? !!ruleResult.failNum :(signupType==='all'?true:false))" @click.stop="ok">{{language().btn_ok}}</yxtf-button> -->
            <yxtf-button size="larger2" type="primary" :disabled="needAttachDisabled || (userList.length ? !!ruleResult.failNum :(signupType==='all'?true:false))" @click.stop="openSponsor(null)">{{language().btn_ok}}</yxtf-button>
         </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SponsorChoose from 'yxt-biz-pc/packages/sponsor-choose';
export default {
  name: 'YxtbizSignupOrder',
  inject: ['language'],
  props: {
    id: {
      type: String,
      default: '1522770722245263361'
    },
    extendedInfo: {
      type: Array,
      default() {
        return [];
      }
    },
    // 调查url
    surveyUrl: {
      type: String,
      default: ''
    },
    // 上传文件配置
    uploadConfig: {
      type: Object,
      default() {
        return {
          appCode: 'kng',
          moduleName: 'test_module',
          functionName: 'test_function',
          max: 3
        };
      }
    },
    extraConditions: {}
  },
  data() {
    return {
      users: [],
      siginup: {},
      data: {},
      points: {},
      attachments: [],
      rules: [],
      ruleResult: {},
      ruleResultCopy: {},
      userList: [],
      needSurveyValue: false,
      si: undefined,
      signupType: '',
      staticBaseUrl: this.$staticBaseUrl,
      num: 0,
      timer: null,
      isLoading: false
    };
  },
  computed: {
    text() {
      // all 可提交人员，num 不符合条件人员
      return window.i18n.t('pc_signup_msg_movetext', {all: this.ruleResult.passNum || 0, num: this.ruleResult.failNum || 0});
    },
    filters() {
      let filters = '';
      if (this.data.attachTypeOptionList && this.data.attachTypeOptionList.length) {
        if (this.data.attachTypeOptionList.includes(1)) {
          filters += '.doc,.docx,.ppt,.pptx,.xls,.xlsx,.pps,.pdf,.zip,.rar';
        }
        if (this.data.attachTypeOptionList.includes(2)) {
          if (filters) {
            filters += ',';
          }
          filters += '.jpg,.jpeg,.gif,.png,.bmp,.ico,.svg';
        }
        if (this.data.attachTypeOptionList.includes(3)) {
          if (filters) {
            filters += ',';
          }
          filters += '.wmv,.mp4,.flv,.avi,.rmvb,.mpg,.mkv,.mov';
        }
      }
      return filters;
    },
    // 上传按钮控制
    needAttachDisabled() {
      if (this.data.needAttach) {
        if (this.users && this.users.length) {
          const userList = this.userList.filter(_ => (_.attachments || []).filter(_ => _.id).length);
          return this.userList.length !== userList.length;
        } else {
          return !this.attachments.filter(_ => _.id).length;
        }
      }
      return false;
    },
    // 人员规则结果
    ruleResultUsers() {
      const data = {};
      const failUsers = this.ruleResultCopy.failUsers || [];
      for (let i = 0; i < failUsers.length; i++) {
        data[failUsers[i].id] = failUsers[i].rules;
      }
      return data;
    }
  },
  watch: {
    extraConditions: {
      handler: function() {
        this.handleData();
      },
      deep: true
    },
    ruleResultCopy: {
      handler: function() {
        this.handleData();
      },
      deep: true
    }
  },
  methods: {
    openSponsor(callback) {
      if (this.isLoading) {
        return false;
      }
      const self = this;
      if (self.data.needAudit === 1) {
        SponsorChoose.open({
          props: { // 传递的值
            code: this.data.auditTemplateCode,
            projId: this.id
          },
          onSuccess(val) {
            self.isLoading = true;
            self.ok(val, callback);
          },
          onError(val) {
            self.isLoading = false;
          },
          onCancel() {
            self.isLoading = false;
          }
        });
      } else {
        self.ok([], callback);
      }
    },
    handleData() {
      if (this.ruleResultCopy) {
        this.ruleResult = JSON.parse(JSON.stringify(this.ruleResultCopy));
        let passIds = this.ruleResult.passUsers.map(item=>item.id);
        // let failIds =this.ruleResult.failUsers.map(item=>item.id)
        if (this.extraConditions && Object.keys(this.extraConditions).length > 0) {
          Object.keys(this.extraConditions).map(item=>{
            if (passIds.indexOf(item) > -1) {
              let name = '';
              this.userList.forEach(user=>{
                if (user.id === item) {
                  name = user.fullname;
                }
              });
              this.ruleResult.passNum--;
              this.ruleResult.failNum++;
              this.ruleResult.passUsers = this.ruleResult.passUsers.filter(s=>s.id !== item);
              this.ruleResult.failUsers.push({id: item, name, rules: JSON.parse(JSON.stringify(this.extraConditions[item]))});
            } else {
              this.ruleResult.failUsers = this.ruleResult.failUsers.map(s=>{
                if (s.id === item) {
                  s.rules.push(JSON.parse(JSON.stringify(this.extraConditions[item])));
                }
                return s;
              });
            }
          });
        }

      }
    },
    // 文件图标
    getIconName(fileClass) {
      if (
        ['word', 'excel', 'ppt', 'pdf', 'img', 'video', 'audio', 'zip'].includes(
          fileClass
        )
      ) {
        return `f_kng-${fileClass}`;
      }
      return 'f_kng-third';
    },
    // 上传前
    beforeUpload(file) {
      this.attachments.push({
        uuid: file.uuid,
        id: file.id || '',
        extension: file.extension,
        fileClass: file.fileClass,
        fileType: file.fileType,
        fullUrl: file.fullUrl || '',
        type: file.type,
        name: file.name,
        size: file.size,
        progress: 0
      });
    },
    // 上传中
    onProgress(file, progress) {
      const f = this.getFile(file.uuid);
      if (f) {
        f.progress = parseInt(progress.toFixed(2) * 100, 10);
      }
    },
    // 上传成功
    onUploaded(file) {
      for (let i = 0; i < this.attachments.length; i++) {
        if (this.attachments[i].uuid === file.uuid) {
          this.attachments[i].id = file.id;
          this.attachments[i].fullUrl = file.fullUrl;
          return;
        }
      }
    },
    // 错误
    onError(error) {
      if (error === 'oversize') {
        this.$message.error(this.$t('pc_biz_imgcropper_msg_oversize'/* 您选择的内容大小已超过允许的大小，请确认! */));
      } else if (error === 'forbidden') {
        this.$message.error(this.$t('pc_biz_imgcropper_msg_type'/* 您选择的内容格式不符合，请确认! */));
      }
    },
    // 找文件
    getFile(uuid) {
      for (const f of this.attachments) {
        if (f.uuid === uuid) {
          return f;
        }
      }
    },
    // 获取大小
    getSize(size) {
      if (!size) {
        return '0 B';
      }
      if (size < 1024) {
        return size.toFixed() + ' B';
      }
      size = size / 1024;
      if (size < 1024) {
        return size.toFixed() + ' K';
      }
      size = size / 1024;
      if (size < 1024) {
        return size.toFixed() + ' M';
      }
      size = size / 1024;
      return size.toFixed() + ' G';
    },
    // 执行前置条件验证
    async exeRules(users = [], rules = []) {
      if (this.siginup) {
        return await this.siginup.check(users.map(_ => _.id), rules);
      }
    },
    // 移除
    async del(id) {
      this.$fmessage({ message: this.language().msg_del_success, type: 'success' });
      this.userList = this.userList.filter(_ => _.id !== id);
      this.$parent.setParams(this.id, 'users', this.userList);
      // this.$emit('extraCondition', this.userList, this.id);
      if (this.userList.length) {
        this.ruleResultCopy = await this.exeRules(this.userList, this.rules.datas);
      } else {
        this.ruleResult = {
          failNum: 0,
          failUsers: [],
          passNum: 0,
          passUsers: [],
          totalNum: 0
        };
      }
      this.$parent.fmessage(this.ruleResult);
    },
    async delAll() {
      // 获取不合格人员id
      let failUsersId = [];
      let failUsersName = [];
      if (this.ruleResult && this.ruleResult.failUsers && this.ruleResult.failUsers.length > 0) {
        failUsersId = this.ruleResult.failUsers.map(item=>{
          return item.id;
        });
        failUsersName = this.ruleResult.failUsers.map(item=>{
          return item.name;
        });
        let message = '';
        if (failUsersId.length === 1) {
          message = this.language().msg_del_success;
        } else {
          message = window.i18n.t('pc_signup_msg_movetext1', {name: failUsersName.slice(0, 3).join('、'), num: failUsersId.length});
        }
        this.$fmessage({ message: message, type: 'success' });
        this.userList = this.userList.filter(user => {
          return failUsersId.indexOf(user.id) === -1;
        });
        // this.$emit('extraCondition', this.userList, this.id);
        this.ruleResult = {
          failNum: 0,
          failUsers: [],
          passNum: this.ruleResult.passNum,
          passUsers: this.ruleResult.passUsers,
          totalNum: 0
        };
        this.$parent.setParams(this.id, 'users', this.userList);
      }

    },
    // 关闭文件
    close(uuid) {
      this.attachments = this.attachments.filter(_ => _.uuid !== uuid);
    },
    // 打开问卷
    openSurvey() {
      window.open(`${this.surveyUrl || location.origin}/survey/fbi.html?type=2&id=${this.data.surveyTaskId}`);
    },
    // 错误信息
    infoMsg(failUsers) {
      // 整理验证
      const infoObj = {};
      for (let i = 0; i < failUsers.length; i++) {
        const rules = failUsers[i].rules || [];
        for (let j = 0; j < rules.length; j++) {
          infoObj[rules[j].ruleName] = infoObj[rules[j].ruleName] || [];
          infoObj[rules[j].ruleName].push(failUsers[i].name);
        }
      }
      // 输出显示
      let msgs = [];
      for (let key in infoObj) {
        msgs.push(key);
      }
      // return msgs.join('\n');
      return msgs.join('、');
    },
    // 确认报名
    async ok(sponsorData, callback) {
      if (this.data.needSurvey) {
        if (!this.needSurveyValue) {
          return this.$fmessage({ message: this.language().msg_form_warning, type: 'warning' });
        }
      }
      // 是否注册报名
      if (this.siginup) {
        const res = this.users && this.users.length ? await this.siginup.runAll(this.userList.map(_ => ({
          userId: _.id,
          attachments: (_.attachments || []).map(file => ({
            fileId: file.id,
            name: file.name,
            fileType: {
              image: 2,
              video: 3
            }[file.fileType] || 1,
            url: file.fullUrl,
            size: file.size,
            mimeType: file.type || file.fileType,
            fileClass: file.fileClass
          }))
        })), sponsorData) : await this.siginup.run((this.attachments || []).map(file => ({
          fileId: file.id,
          name: file.name,
          fileType: {
            image: 2,
            video: 3
          }[file.fileType] || 1,
          url: file.fullUrl,
          size: file.size,
          mimeType: file.type || file.fileType,
          fileClass: file.fileClass
        })), sponsorData);
        this.isLoading = false;
        if (res.error) {
          this.$fmessage({ message: res.error.message, type: 'warning' });
        } else {
          // 循环请求结果
          this.getResult(res.ticket, callback);
        }
      }
    },
    // 获取报名结果
    async getResult(ticket, callback) {
      if (this.siginup) {
        const res = await this.siginup.getResult(ticket);
        if (res.error) {
          this.$fmessage({ message: res.error.message, type: 'warning' });
        } else {
          if (callback) {
            callback(res);
            return false;
          }
          if (res.totalNum) {
            if (res.failUsers && res.failUsers.length) {
              this.ruleResult = res;
              if (!(this.users && this.users.length)) {
                this.$parent.handleOpen({
                  type: 'submit',
                  width: 520,
                  center: true,
                  class: 'yxtbiz-signup_order_dialog'
                }, {
                  id: this.id,
                  svgImgName: 'warning',
                  title: this.language().msg_sigin_up_fail,
                  info: this.infoMsg(res.failUsers),
                  // 可报名的人数
                  rangeEnrollCount: res.rangeEnrollCount,
                  // 允许报名数
                  allowEnrollCount: res.allowEnrollCount
                }, () => {
                  this.$emit('toMy', this.id);
                  this.$parent.handleClose();
                }, () => {
                  this.$emit('toDetails', this.id);
                  this.$parent.handleClose();
                }, () => {
                  // 继续报名
                  this.$emit('toContinue', this.id);
                  this.$parent.handleClose();
                });
              } else {
                this.$fmessage({ message: this.language().msg_sigin_up_warning, type: 'warning' });
              }
            } else {
              if (!this.data.needAudit) {
                // 是否是替补通过 0 否 1是
                let title = this.language().msg_sigin_up_success;
                if (res.substituteAndPass === 1) {
                  title = this.language().msg_signup_pass;
                }
                this.$parent.handleOpen({
                  type: 'submit',
                  width: 520,
                  center: true,
                  class: 'yxtbiz-signup_order_dialog'
                }, {
                  id: this.id,
                  svgImgName: 'success',
                  title: title,
                  info: '',
                  // 可报名的人数
                  rangeEnrollCount: res.rangeEnrollCount,
                  // 允许报名数
                  allowEnrollCount: res.allowEnrollCount
                }, () => {
                  this.$emit('toMy', this.id);
                  this.$parent.handleClose();
                }, () => {
                  this.$emit('toDetails', this.id);
                  this.$parent.handleClose();
                }, () => {
                  // 继续报名--需要把报名详情的is为true
                  this.$emit('toContinue', this.id);
                  this.$parent.handleClose();
                });
              } else {
                this.$parent.handleOpen({
                  type: 'submit',
                  width: 520,
                  center: true,
                  class: 'yxtbiz-signup_order_dialog'
                }, {
                  id: this.id,
                  svgImgName: 'tip',
                  title: this.language().msg_to_audit_success,
                  info: this.language().msg_to_audit_info,
                  // 可报名的人数
                  rangeEnrollCount: res.rangeEnrollCount,
                  // 允许报名数
                  allowEnrollCount: res.allowEnrollCount
                }, () => {
                  this.$emit('toMy', this.id);
                  this.$parent.handleClose();
                }, () => {
                  this.$emit('toDetails', this.id);
                  this.$parent.handleClose();
                }, () => {
                  // 继续报名
                  this.$emit('toContinue', this.id);
                  this.$parent.handleClose();
                });
              }
            }
          } else {
            clearTimeout(this.timer);
            // this.getResult(ticket);
            this.timer = setTimeout(()=>{
              if (this.num <= 5) {
              // 循环请求结果
                this.getResult(ticket, callback);
                this.num++;
              } else {
                this.$fmessage({ message: this.language().msg_save_fail, type: 'warning' });
                this.num = 0;
              }
            }, 300);
          }
        }
      }
    },
    // 打开附件
    openFile(user) {
      this.$parent.handleOpen({
        title: this.language().tit_upload_file,
        type: 'upload',
        width: 640,
        footer: true,
        cutline: true,
        paddingSize: true,
        class: 'uploadTitle'
      }, {
        filters: this.filters,
        attachments: user.attachments || [],
        attachTypeOptionList: this.data.attachTypeOptionList
      }, () => {
        this.$parent.handleClose();
      }, (data) => {
        this.$set(user, 'attachments', data.attachments);
        this.$parent.handleClose();
      });
    }
  },
  beforeDestroy() {
    if (this.si) {
      clearInterval(this.si);
      this.si = undefined;
    }
  },
  async created() {
    const SDK = this.$parent.SDK;
    // 用户列表--代报名才有用户列表
    this.signupType = sessionStorage.getItem('signupType');
    if (sessionStorage.getItem('signupType') === 'all') {

      this.users = this.$parent.getParams(this.id, 'users') || [];
    }

    this.userList = [...this.users];
    // 获取详情
    this.data = await SDK.getProjectDetail(this.id);
    this.$emit('callback', this.data);
    this.$parent.fmessage(this.data);
    // 获取积分
    this.points = await SDK.getCurrentUserPoints();
    this.$parent.fmessage(this.points);
    // 注册项目
    this.siginup = new SDK(this.data.id);
    // 按钮控制
    const kongz = await this.siginup.getButtons(this.id);
    this.$parent.fmessage(kongz);
    this.data = {
      ...this.data,
      ...kongz
    };
    // 规则验证
    this.rules = await this.siginup.getRules();
    this.$parent.fmessage(this.rules);
    // this.ruleResult = await this.exeRules(this.userList, this.rules.datas);
    this.ruleResultCopy = await this.exeRules(this.userList, this.rules.datas);
    this.$parent.fmessage(this.ruleResultCopy);
    // 业务需要 获取额外的规则，返回的值赋值给this.extraConditions
    this.$emit('extraCondition', this.userList, this.id);
    // 调查结果
    if (this.data.id && this.data.needSurvey && this.data.surveyTemplateId && !this.users.length) {
      this.si = setInterval(async() => {
        const res = await this.siginup.getSurvey();
        if (res.result) {
          this.needSurveyValue = true;
          clearInterval(this.si);
          this.si = undefined;
        }
      }, 1000);
    }
  }
};
</script>

<style lang="scss" scoped>
.yxtbiz-signup-order {
  display: flex;
  flex-direction: column;
}
</style>
